import { IOfferHomeowner } from '../../../../../../redux/reducers';

import { ECommercialOwnershipVerificationFormViewFields } from '../../enums';
import { TCommercialOwnershipVerificationFormViewState } from '../../types';
import { fieldsByType } from '../maps';

export const getRequiredFieldsValue = (formState: Partial<TCommercialOwnershipVerificationFormViewState>) => {
  const identificationPersonType =
    formState[ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType]?.value;

  if (!identificationPersonType) {
    return undefined;
  }

  const requiredFields = fieldsByType[identificationPersonType].require;

  return requiredFields.reduce(
    (acc, fieldName) => ({
      ...acc,
      [fieldName]: formState[fieldName]?.value,
    }),
    {} as IOfferHomeowner,
  );
};
